<template>
  <div class="querydept_main">
    <ball></ball>
    <div class="nav">
       <van-nav-bar
        title="科室类别"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
    </div>
    <div class="body">
      <div>
        <!--  -->
        <van-sidebar v-model="activeKey" type="primary" class="dypeList">
          <van-sidebar-item
            v-for="(item, index) in dypeList"
            :key="index"
            :title="item.deptName"
             @click="getregLevelIdInfo(item.deptId, index, item.deptName,item)"
          />
           
        </van-sidebar>
      </div>
      <div class="querydept_cell">
        <div>
          <div v-if="emptyflag">
            <van-empty image="https://account.kmmds.top/datainfo_pic/error.png" description="该科室暂无排班" />
          </div>
          <van-cell
            v-else
            is-link
            class="cellltem"
            title="预约挂号"
            @click="godocLIst(key)"
          />
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./../../components/nav.vue";
import { Dialog } from "vant";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  data() {
    return {
      //单元格点击事件  true 有排班  false没排班
      clickflag: null,
      regfre: "",
      Cflag: true,
      deptflag: false,
      name: "",
      isFirstEnter: false,
      navTitle: "科室列表",
      activeKey: 0,
      index: 0,
      dypeList: [],
      depy_type: "",
      method_depy_type: [],
      reglevelList: [],
      emptyflag: false,
      dept_id: null,
      empty_D_flag: false,
      //挂号排班类型
      register_sched: "",
      // 挂号级别
      register_level: "",
      wx_pub_id: "",
    };
  },
  components: {
    Nav,
  },
  mounted() {
    // this.getDeptList();
    this.getrerinfo();
  },
  methods: {
    onClickLeft() {
      this.$router.push("/index");
    },

    //判断版本和排版类型
    async getrerinfo() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getdictionaries";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            //  console.log(data.data)
            this.wx_pub_id = data.data.wx_pub_id;
            // 挂号级别
            this.register_level = data.data.register.register_level;
            //  排班
            this.register_sched = data.data.register.register_sched;
            //  挂号类型
            this.register_type = data.data.register.register_type;
            this.getDeptList();
            // if (register_sched == "Y") {
            //   //通过科室ID获取该科室下的挂号级别列表
            //   this.getDeptList();
            // } else if (this.register_sched == "N") {
            //   //显示挂号预约按钮
            //   //判断是否有挂号级别===》
            //   if (this.register_level == "Y") {
            //     this.getDeptList();
            //   } else if (this.register_level == "N") {
            //     this.regfre = data.data.register.price;
            //     this.Cflag = false;
            //     this.getDeptList();
            //   }
            // }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    //跳转下一页 传递参数
    godocLIst(key) {
      // console.log(this.name)
      // console.log(key)
      // this.$router.push({
      //   path: "/schedulhead",
      //   query: {
      //     dept_deptId: this.method_depy_type.deptId,
      //     dype_type_name: key,
      //     dype_type_key: "NULL",
      //     dypename: this.name,
      //   },
      // });
      // console.log("key", key);
      if (this.wx_pub_id = 1016) {
        this.$router.push({
          path: "/newschedulhead",
          query: {
            dept_deptId: this.method_depy_type.deptId,
            dype_type_name: key,
            dype_type_key: "NULL",
            dypename: this.name,
          },
        });
      } else {
        this.$router.push({
          path: "/schedulhead",
          query: {
            dept_deptId: this.method_depy_type.deptId,
            dype_type_name: key,
            dype_type_key: "NULL",
            dypename: this.name,
          },
        });
      }

      // console.log(dept_deptId)
    },
    //获取挂号类型和id
    async getregLevelIdInfo(deptId, index, name, item) {
      this.dept_id = deptId;
      this.method_depy_type = this.dypeList[index];
      this.name = name;
      if (item.cost) {
        this.regfre = item.cost;
      }
      //  console.log(this.name)
      //  console.log(deptId)
      try {
        this.$showLoad();
        let url = "/register/queryschedulheadBydeptId";
        let R_data = { deptId: deptId };
        // console.log(R_data)
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          R_data,
          async (data) => {
            this.reglevelList = data.data;
            if (this.reglevelList == null) {
              this.empty_D_flag = true;
            } else {
              this.empty_D_flag = false;
            }
            // console.log(this.reglevelList)
            // console.log(!this.reglevelList['主任医师号'],!this.reglevelList['副主任医师号'],!this.reglevelList['急诊号'],!this.reglevelList['普通挂号'])

            if (
              !this.reglevelList["主任医师号"] &&
              !this.reglevelList["副主任医师号"] &&
              !this.reglevelList["急诊号"] &&
              !this.reglevelList["普通挂号"] &&
              !this.reglevelList["免挂号"]
            ) {
              this.emptyflag = true;
            } else {
              this.emptyflag = false;
            }
            // if(!(this.reglevelList&&this.reglevelList['普通挂号'])){
            //   this.dypeList.splice(index,1);
            //   await this.getregLevelIdInfo(this.dypeList[0].deptId,0);
            //   }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    async getDeptList() {
      //获取科室列表
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/querydept";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.dypeList = data.data.data;
            // console.log(this.dypeList)
            /**
             挂号排班类型
             @register_sched
             挂号级别
              @register_level
             */
            if (this.register_sched == "Y") {
              this.clickflag = true;
              this.getregLevelIdInfo(
                this.dypeList[0].deptId,
                0,
                this.dypeList[0].deptName,
                this.dypeList[0]
              );
            } else if (this.register_sched == "N") {
              this.clickflag = false;
              //显示挂号预约按钮
              //判断是否有挂号级别===》
              if (this.register_level == "Y") {
                this.NO_getregLevelIdInfo(
                  this.dypeList[0].deptId,
                  0,
                  this.dypeList[0].deptName
                );
              } else if (this.register_level == "N") {
                this.clickflag = true;
                this.getregLevelIdInfo(
                  this.dypeList[0].deptId,
                  0,
                  this.dypeList[0].deptName,
                  this.dypeList[0]
                );
                this.Cflag = false;
              }
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.van-sidebar-item--select::before {
  background-color: #5b8df6;
}
.querydept_main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  max-width: 100vw;
}
.body {
  flex: 1;
  display: flex;
  flex-direction: row;
  .dypeList {
    max-height: 94vh;
    width: 28vw;
    line-height: 50px;
  }
  .dis {
    font-size: 14px;
    line-height: 35px;
    color: #7f8c8d;
    text-align: left;
  }
  .querydept_cell {
    display: flex;
    flex-direction: column;
    width: 80vw;
    height: 90vh;

    .D_btn_right {
      height: 85vh;
      .aa {
        height: 85vh;
      }
    }
    .cellltem {
      line-height: 35px;
      text-align: center;
    }
  }
}
</style>